<template>
    <div class="mod-container">
      <div class="recommend-container">
        <van-cell title-class="form-label" is-link center title="开启智能推荐">
          <template #right-icon>
            <van-switch active-color="#1677FF" v-model="isRecommend" size="24" @change="clear"/>
          </template>
        </van-cell>
        <div class="recommend-props-wrap" v-if="isRecommend">
          <div class="van-cell" @click="showPicker = true">
            <div class="van-cell__title form-label form--required" style="flex: 1">
              <span>样本分类</span>
            </div>
            <div class="van-cell__value template-category" style="flex: 2">
              <span>{{currentSubCategory.dictValue}}</span>
            </div>
            <i class="van-icon van-icon-arrow van-cell__right-icon"></i>
          </div>
          <div class="van-cell">
            <div class="van-cell__title form-label form--required" style="flex: 1">
              <span>样本数量</span>
            </div>
            <div class="van-cell__value template-count" style="flex: 2">
              <van-radio-group v-model="templateCount" direction="horizontal" @change="handleSearchRecommend()">
                <van-radio :name="1">16以下</van-radio>
                <van-radio :name="2">17-29</van-radio>
                <van-radio :name="3">30以上</van-radio>
              </van-radio-group>
            </div>
          </div>
        </div>
      </div>
      <div v-if="isLoading">
        <div v-for="(item, index) in dataList" :key="index">
          <div class="info-box " :class="[selectIndex == index ? 'selected' : '', checkItemCanSelect(item) ? '' : 'no-select']" @click="onSelectTech(item, index)">
            <div class="top">
              <div class="recommend_tip" v-if="handleCheckIsRecommend(item)">推荐</div>
              <span class="tech-title" v-text="item.dictValue"></span>
            </div>
            <span class="tech-desc" v-text="item.extraValue"></span>
          </div>
        </div>
      </div>
      <van-popup v-model="showPicker"  closeable
                 close-icon="close" round :style="{ width: '98%', height: '40%' }">
        <div class="pop-title"><span>样本分类</span></div>
        <div class="item-title"><span>样本类型</span></div>
        <div class="flex-row sample-wrapper">
          <div v-for="(item, index) in sampleCategories" :key="index" class="flex-grow-1">
            <div :class="['radio-tag', currentCategory.dictKey == item.dictKey ? 'radio-tag__checked' : '']"
                 @click="handleSelectCategory(item)">
              {{ item.dictValue}}
            </div>
          </div>
        </div>
        <div v-for="(category, k) in sampleCategories" :key="k">
          <div v-if="currentCategory && currentCategory.dictKey === category.dictKey">
            <div class="item-title"><span v-text="currentCategory.extraValue"></span></div>
            <div class="flex-row sample-wrapper">
              <div v-for="(item, index) in sampleSubCategories" :key="index" class="flex-grow-1" v-if="category.dictKey === item.parentId">
                <div :class="['radio-tag', currentSubCategory.dictKey == item.dictKey ? 'radio-tag__checked' : '']"
                     @click="handleSubSelectCategory(item)">
                  {{ item.dictValue}}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="pop-button-wrap">
          <div class="pop-button" @click="handleSearchRecommend()">
            <span>确定</span>
          </div>
        </div>
      </van-popup>
    </div>
</template>
<script>
  import Emkt from '../../../emkt'

  export default {
    data () {
      return {
        isLoading: true,
        isRecommend: false,
        showPicker: false,
        templateCount: -1,
        selectIndex: 0,
        allRecommendations: [],
        recommendations: [],
        sampleCategories: [],
        sampleSubCategories: [],
        currentCategory: Object.assign({}),
        currentSubCategory: Object.assign({})
      }
    },
    props: {
      dataList: {
        type: [Object, Array],
        default: Object.assign({})
      }
    },
    created () {
      this.getMeteData()
      this.fetchRecommendList()
    },
    methods: {
      clear () {
        if (this.isRecommend) {
          this.selectIndex = null
          this.$parent.handleProduct(null)
        } else {
          this.selectIndex = 0
          this.$parent.handleProduct(this.dataList[0])
          this.currentCategory = Object.assign({})
          this.currentSubCategory = Object.assign({})
          localStorage.removeItem('sample')
          this.templateCount = -1
        }
      },
      sendInfo () {
        if (this.isRecommend) {
          if (JSON.stringify(this.currentCategory) !== '{}') {
            let sample = {
              currentCategory: Object.assign({}, this.currentCategory),
              currentSubCategory: Object.assign({}, this.currentSubCategory)
            }
            localStorage.setItem('sample', JSON.stringify(sample))
          } else {
            localStorage.removeItem('sample')
          }
        } else {
          localStorage.removeItem('sample')
        }
      },
      getMeteData () {
        let dictionary = Emkt.getEmktMetaData().dictionariesMap
        for (const key1 in dictionary[71007]) {
          if (dictionary[71007][key1].dictValue !== '-') {
            this.sampleCategories.push(dictionary[71007][key1])
          }
        }
        for (const key2 in dictionary[71008]) {
          let obj = dictionary[71008][key2]
          let extraValue = obj.extraValue
          // 解析 parentId 和 loSampleTypeId
          // extraValue eg: {"parentId":1, loSampleTypeId:10}
          if (extraValue) {
            let extraValueMap = JSON.parse(extraValue)
            obj.parentId = extraValueMap.parentId
            obj.loSampleTypeId = extraValueMap.loSampleTypeId
          }
          this.sampleSubCategories.push(obj)
        }
        console.log('sampleSubCategories', this.sampleSubCategories)
      },
      fetchRecommendList () {
        let that = this
        this.gcapi('getProteomicsBasicData', '').then(res => {
          if (res.data.code === 0) {
            that.allRecommendations = res.data.result.proteomicsRecommendation
          }
        })
      },
      onSelectTech (currentItem, targetIndex) {
        if (this.isRecommend) {
          let result = this.recommendations.some((res) => {
            return res.productCategory === parseInt(currentItem.dictKey)
          })
          if (!result) {
            return
          }
        }
        this.selectIndex = targetIndex
        localStorage.setItem('selectProductIndex', this.selectIndex)
        this.$emit('callback', currentItem)
      },
      handleCheckIsRecommend (prod) {
        return this.isRecommend && this.recommendations.some(v => {
          return v.productCategory === prod.dictKey && v.recommendFlag === 1
        })
      },
      handleSelectCategory (currentCategory) {
        this.currentCategory = currentCategory
      },
      handleSubSelectCategory (currentSubCategory) {
        this.currentSubCategory = Object.assign({})
        this.currentSubCategory = currentSubCategory
      },
      handleSearchRecommend () {
        this.isLoading = false
        if (this.isRecommend) {
          this.selectIndex = null
        }
        this.recommendations = this.allRecommendations
        this.recommendations = this.recommendations.filter(v => v.sampleQuantity === this.templateCount)
        if (this.currentSubCategory.dictKey !== undefined) {
          this.recommendations = this.recommendations.filter(v => v.sampleCategory === this.currentSubCategory.dictKey)
        }
        if (JSON.stringify(this.currentSubCategory) === '{}') {
          this.recommendations = this.recommendations.filter(v => v.sampleCategory !== 1)
        }
        this.showPicker = false
        this.isLoading = true
        this.$forceUpdate()
      },
      checkItemCanSelect (prod) {
        if (!this.isRecommend) {
          return true
        }
        return this.recommendations.some(v => {
          return v.productCategory === prod.dictKey && v.selectable === 1
        })
      }
    }
  }
</script>
<style scoped>
  .info-box {
    position: relative;
    background: #FFFFFF;
    border-radius: 12px;
    margin: 10px 0;
    text-align: center;
    height: 100%;
    flex: 1;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(239, 238, 243, 1);
    padding-bottom: 20px;
  }
  .selected {
    border: 1px solid #5878FA;
  }

  .info-box .top {
    z-index: 100;
    position: relative;
    flex: 1;
    width: 100%;
    padding: 21px 15px 0px 15px;
    overflow: hidden;
    border-radius: 10px 10px 0 0;
  }
  .recommend_tip {
    position: absolute;
    top: -6px;
    left: -34px;
    transform: rotate(-45deg);
    background: #5878fa;
    line-height: 10px;
    width: 100px;
    height: 22px;
    padding-top: 10px;
    text-align: center;
    font-size: 10px;
    color: #fff;
    padding-right: 15px;
  }
  .selected span {
    color: #5878FA;
  }

  .info-box span {
    display: block;
  }
  .tech-title {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #424242;
  }
  .tech-desc {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #424242;
    line-height: 17px;
  }
  .recommend-container {
    margin: 10px 0;
    background: #FFFFFF;
    border-radius: 10px;
    border: 1px solid #EFEEF3;
    padding: 2px
  }
  .recommend-container .template-count {
    text-align: left;
  }
  .recommend-container .template-category {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #979797;
    line-height: 20px;
    text-align: left;
  }
  .recommend-props-wrap .van-cell__title {
    max-width:76px;
  }

  .pop-button-wrap {
    display: flex;
    width: 100%;
    position: absolute;
    bottom: 10px;
  }
  .pop-button {
    justify-content: center;
    align-items: center;
    margin: 10px 20px;
    width: 100%;
    height: 40px;
    background-color: #5d7bf2;
    border-radius: 20px;
    text-align: center;
  }
  .pop-title {
    margin: 15px 0;
    align-items: center;
    text-align: center;
    font-size: 16px;
    font-weight: bold;
  }
  .item-title {
    margin: 5px 20px;
    font-size: 14px;
    font-weight: bold;
  }
  .pop-button span {
    color: #ffffff;
    line-height: 40px;
    vertical-align: middle;
  }
  .sample-wrapper {
    padding: 0 20px;
  }
  .radio-tag {
    margin: 2px;
    padding: 2px 5px;
    border: 1px solid #efeef3;
    border-radius: 15px;
    text-align: center;
    align-items: center;
    color: #797979;
    background-color: #efeef3;
    font-size: 12px;
  }
  .radio-tag__checked {
    color: #657ce1;
    border: 1px solid #657ce1;
    background-color: #e0ecfd;
  }
  .no-select{
    pointer-events: none;
  }
  .no-select span{
    color: #979797;
  }
</style>



// WEBPACK FOOTER //
// QuantitativeTech.vue?768c90c9